<template>
  <div>
    <div class="pb-6">
      <div class="row align-items-center py-4 w-100">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $route.meta.title }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <!-- Menu -->
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
        </div>
      </div>
    </div>

    <div class="container-fluid mt--6">
      <form @submit.prevent="storeArtworkCategory(artworkCategory)">
        <div class="row">
          <div class="col-md-12">
            <div class="card-wrapper">
              <div class="card">
                <div class="card-header">
                  <h4>Information</h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12 mt-4">
                      <label class="form-control-label">Cover</label>
                      <UploadFiles
                        v-model="artworkCategory.cover"
                        :url="'/artwork-categories/media'"
                        :collection_name="'artwork_category_cover'"
                        :size="2"
                        :model_id="0"
                        :multiple="false"
                      />
                    </div>
                    <div class="col-md-12 mt-4">
                      <label class="form-control-label">Name</label>
                      <input
                        v-model="artworkCategory.name_en"
                        class="form-control"
                        id="name_en"
                        type="text"
                        name="name_en"
                      />
                      <div class="text-red-600 mt-1">
                        <div
                          v-for="message in validationErrors?.name_en"
                          :key="message.id"
                        >
                          {{ message }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mt-4">
                      <label class="form-control-label">Slug</label>
                      <input
                        v-model="artworkCategory.slug"
                        class="form-control"
                        id="slug"
                        type="text"
                        name="slug"
                      />
                      <div class="text-red-600 mt-1">
                        <div
                          v-for="message in validationErrors?.slug"
                          :key="message.id"
                        >
                          {{ message }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-md-12 mt-4">
                      <label class="form-control-label">Name Ar</label>
                      <input
                        v-model="artworkCategory.name_ar"
                        class="form-control"
                        id="name_ar"
                        type="text"
                        name="name_ar"
                      />
                    </div> -->
                    <div class="col-md-12 mt-4">
                      <div class="form-group d-flex flex-column justify-content-start">
                        <label for="parent_id">Parent Category</label>
                        <Dropdown class="w-100" :filter="true" :showClear="true" v-model="artworkCategory.parent_id"
                          :options="artworkCategoryMeta.parent" optionLabel="name_en" optionValue="id" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer d-flex justify-content-between"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 d-flex justify-content-between">
            <Button @click.prevent="
                router.push({
                  name: 'artwork-categories.index',
                })
              " label="Cancel" class="p-button-secondary" />
            <Button type="submit" label="Save" class="p-button-success" />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useAbility } from "@casl/vue";

import useArtworkCategories from "@/composables/ArtworkCategories";


import UploadFiles from "@/components/UploadFiles";

export default {
  components: {
    UploadFiles,
  },
  setup() {
    const artworkCategory = reactive({
      cover: ref([]),
      name_en: ref(""),
      name_ar: ref(""),
      slug: ref(""),
      parent_id: "",
    });

    const {
      artworkCategoryMeta,
      getArtworkCategoryMeta,
      storeArtworkCategory,
      validationErrors,
      isLoading,
    } = useArtworkCategories();

    const router = useRouter();
    const { can } = useAbility();
    onMounted(() => {
      getArtworkCategoryMeta();
    });

    watch(artworkCategory, (current) => {
      artworkCategory.slug = current.name_en
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
    });

    return {
      router,
      artworkCategory,
      artworkCategoryMeta,
      storeArtworkCategory,
      validationErrors,
      isLoading,
      can,
    };
  },
  methods: {},
  mounted() {},
};
</script>

